module.exports = __webpack_public_path__ + "img/Step3.4fee0996.png";